<template>
    <div class="lzPlayer"  style="width:100%;position: relative"
         :style="'height:' + height">
        <div class="tips"
             v-if="isno"
             @click="closeel">
            若视频无法播放，请升级或更换浏览器 <i class="el-icon-close"></i>
        </div>
        <div class="prism-player"
             :id="playerId"
             :style="playStyle"></div>
        <div class='video-muted' v-if="ismouted" @click="myplays()"></div>
        <!-- <div class='video-muted' v-if="isplays" @click="play(0.3)"></div> -->

        <div class="errorbox"
             v-if="state > 0"
             :class="anchor && (state == 3 || state == 4) ? 'bgbox' : ''">
            <div v-if="state == 1">
                <div class="text">
                  <img src="/static/newroom/loadings.png" alt="" srcset="">
                </div>
            </div>
            <!-- <img src="" alt="" srcset=""> -->
            <div class="text"
                 v-else-if="state == 2">
                <img src="/static/newroom/loadings.png" alt="" srcset="">
            </div>
            <div v-else-if="state == 3">
                <div class="novideo1"
                     v-if="anchor">
                    <img :src="`${$store.state.imgUrl}/noanchor.gif`"
                         alt="龙珠直播" />
                    <span>主播正在赶来的路上！</span>
                </div>
                <div v-else>
                    <div class="text">当前{{ txtLive }}已结束</div>
                    <div class="text1">请去观看其他比赛</div>
                    <div class="changebutton">
                        <span class="reloadPlay"
                              @click="reload()">刷新</span>
                    </div>
                </div>
            </div>
            <!-- <div v-else-if="state == 4">
                <div class="novideo1"
                     v-if="anchor">
                    <img :src="`${$store.state.imgUrl}/noanchor.gif`"
                         alt="龙珠直播" />
                    <span>主播正在赶来的路上！</span>
                </div>
                <div v-else>
                    <div class="text">当前直播加载失败</div>
                    <div class="text1">请手动刷新或观看其他直播</div>
                    <div class="changebutton">
                        <span class="reloadPlay"
                              @click="reload()">刷新</span>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
  import {Tooltip,Slider,Popover} from 'element-ui';
import Vue from "vue";
export default {
    name: 'Aliplayer',
    props: {
        rePlay:{
            type: Boolean,
            default: false,
        },
        qualityHD: {
            type: String,
            default: '',
        },
        hasSD: {
            type: Boolean,
            default: false,
        },
        hasHD: {
            type: Boolean,
            default: false,
        },
        hdlist: {
            type: Array,
            default:function(){
              return []
            },
        },
        islogin: {
            type: Boolean,
            default: false,
        },
        showfull: {
            type: Boolean,
            default: false,
        },
        showPicture:{
          type: Boolean,
          default: true,
        },
        maxLen: {
            type: Number,
            default: 100,
        },
        sleep: {
            type: Number,
            default: 3,
        },
        chatParams: {
            type: Object,
            default:function(){
              return {}
            },
        },
        showad: {
            type: Boolean,
            default: false,
        },
        anchor: {
            type: Boolean,
            default: false,
        },
        playStyle: {
            type: String,
            default: '',
        },
        aliplayerSdkPath: {
            // Aliplayer 代码的路径
            type: String,
            default: '//g.alicdn.com/de/prismplayer/2.8.8/aliplayer-min.js',
        },
        autochange: {
            type: Boolean,
            default: false,
        },
        // 是否显示弹幕
        showdm: {
            type: Boolean,
            default: true,
        },
        autoplay: {
            type: Boolean,
            default: true,
        },
        isLive: {
            type: Boolean,
            default: true,
        },
        playsinline: {
            type: Boolean,
            default: true,
        },
        width: {
            type: String,
            default: '100%',
        },
        height: {
            type: String,
            default: '100%',
        },
        controlBarVisibility: {
            type: String,
            default: 'hover',
        },
        useH5Prism: {
            type: Boolean,
            default: true,
        },
        useFlashPrism: {
            type: Boolean,
            default: false,
        },
        vid: {
            type: String,
            default: '',
        },
        playauth: {
            type: String,
            default: '',
        },
        source: {
            type: String,
            default: '',
        },
        cover: {
            type: String,
            default: '',
        },
        format: {
            type: String,
            default: 'm3u8',
        },
        x5_video_position: {
            type: String,
            default: 'top',
        },
        x5_type: {
            type: String,
            default: 'h5',
        },
        x5_fullscreen: {
            type: Boolean,
            default: false,
        },
        x5_orientation: {
            type: Number,
            default: 2,
        },
        autoPlayDelay: {
            type: Number,
            default: 0,
        },
        autoPlayDelayDisplayText: {
            type: String,
        },
    },
    data () {
        return {
            playerId: 'hbPlayer',
            scriptTagStatus: 0,
            instance: null,
            isReload: false,
            state: 0,
            ispused: false,
            dmclose: false,   // 是否显示弹幕

            PictureClose:true, // 画中画
            dmtop: 0,         // 弹幕置顶
            dmtime: 0,
            txtLive: '视频',
            isLives: true,
            src: '',
            ismouted: false,// 声音
            isplays:false, // 播放
            sources: '',
            list: [],
            send: true,
            cutTime: 3,
            waitcount: 0,
            isno: false,
            isfirst: true,
            codeurl: '',
            initTime: 0,
            adtcPic: {},//广告
            seeTime: 0,//歷史观看总时长
            overTime: 30,//观看超过几秒钟弹框
            seeTimes: 0,//观看总时长
            smallshow: true,//未登录下是否弹框过
            smallTime: 10,//未登录下高清，观看超过几秒弹框
            runLocalTime: 0, //观看任务,
            isevent: 0,
            bulletScreen: ''//跑马灯文案
        }
    },
    beforeDestroy () {
        // 实例销毁之前对点击事件进行解绑
        window.removeEventListener('click', this.clickOther)
    },
    created () {
        this.isLives = this.isLive
        this.txtLive = this.isLives ? '直播' : '视频'
        this.codeurl =
            this.$store.state.codeimg +
            encodeURIComponent(this.$store.state.fromchanel + '&pos=hbny-tanchuang')
        this.cutTime = this.sleep
        // this.getBanner(22)
        // this.getBanner(26)
        this.initQuality()
    },
    mounted () {
        this.$nextTick(() => {
            window.addEventListener('click', this.clickOther)
            let s = this.getExplorer()
            if (
                (s.broswer == 'Safari' && parseFloat(s.version) < 10) ||
                s.broswer == 'Edge'
            ) {
                this.isno = true
            }
            // this.tabVolume()
        })
    },
    methods: {
        initQuality () {
            //初始化判断当前播放的码率，未登录并当日观看超2分钟只能看普清，其他可看超清
            let today = new Date().getDate() + '', see1 = '', see2 = 0;
            if (localStorage.getItem('seeDay')) {
                see1 = localStorage.getItem('seeDay').split(',')[0]
                see2 = parseInt(localStorage.getItem('seeDay').split(',')[1])
            }
            if (see1 != today) {
                this.seeTime = 0
            } else {
                this.seeTime = see2
            }
            this.seeTimes = this.seeTime
            if (this.islogin && localStorage.getItem('seeLive')) {
                let uid = this.$store.state.user.info.uid
                let seeLive1 = localStorage.getItem('seeLive').split(',')[0]
                let time = parseInt(localStorage.getItem('seeLive').split(',')[1])
                if (seeLive1 == uid) {
                    // this.watchlive(uid, time)
                }
            }
            this.initAliplayer()
        },
        getBanner (type) {
            this.$axios.get('/api/advert/list?type=3&sub_type=' + type).then((res) => {
                let { list } = res
                if (type == 22) {
                    this.adtcPic = list ? list[0] : {}
                } else {
                    this.bulletScreen = list ? list[0].title : ''
                }
            })
        },
        getExplorer () {
            var Sys = {}
            var ua = navigator.userAgent.toLowerCase()
            var s
                ; (s = ua.match(/edge\/([\d.]+)/))
                    ? (Sys.edge = s[1])
                    : (s = ua.match(/rv:([\d.]+)\) like gecko/))
                        ? (Sys.ie = s[1])
                        : (s = ua.match(/msie ([\d.]+)/))
                            ? (Sys.ie = s[1])
                            : (s = ua.match(/firefox\/([\d.]+)/))
                                ? (Sys.firefox = s[1])
                                : (s = ua.match(/chrome\/([\d.]+)/))
                                    ? (Sys.chrome = s[1])
                                    : (s = ua.match(/opera.([\d.]+)/))
                                        ? (Sys.opera = s[1])
                                        : (s = ua.match(/version\/([\d.]+).*safari/))
                                            ? (Sys.safari = s[1])
                                            : 0
            if (Sys.edge) return { broswer: 'Edge', version: Sys.edge }
            if (Sys.ie) return { broswer: 'IE', version: Sys.ie }
            if (Sys.firefox) return { broswer: 'Firefox', version: Sys.firefox }
            if (Sys.chrome) return { broswer: 'Chrome', version: Sys.chrome }
            if (Sys.opera) return { broswer: 'Opera', version: Sys.opera }
            if (Sys.safari) return { broswer: 'Safari', version: Sys.safari }
            return { broswer: '', version: '0' }
        },
        tabVolume () {
            let _this = this
            let volumetag = document.getElementsByClassName('prism-volume')[0]
            if (volumetag) {
                volumetag.addEventListener('click', () => {
                    if (_this.ismouted) {
                        _this.setVolume(0.3)
                    } else {
                        _this.setVolume(0.3)
                    }
                })
            }
        },
        closeel () {
            this.isno = false
        },
        clickOther () {
            if (this.ismouted) {
                this.setVolume(0.3)
            } else {
                window.removeEventListener('click', this.clickOther)
            }
            this.tabVolume()
            this.changeMouted(0)
        },
        changeMouted (k) {
            let volumetag = document.getElementsByClassName('prism-volume')
            let dmtag = document.getElementById('prismdm')
            if (k == 0) {
                if (volumetag) {
                    volumetag[volumetag.length - 1].style.display = 'block'
                }
                if (dmtag) {
                    dmtag.style.right = '100px'
                }
            } else {
                if (volumetag) {
                    for (var i = 0; i < volumetag.length; i++) {
                        volumetag[i].style.display = 'none'
                    }
                }
                if (dmtag) {
                    dmtag.style.right = '150px'
                }
            }
        },
        videoState (val) {
            this.state = val
        },
        watchlive (uid, time) {
            this.$axios.post('/api/task/watch-pc-live', {
                watch_time: time,
                user_id: uid,
            })
            localStorage.setItem('seeLive', uid + ',' + 0)
        },
        initAliplayer () {
            const _this = this
            this.sources = this.source
            let Components = []
            Components.push({ name: 'logoComponent', type: _this.logoComponent() })
            if (_this.isLives) {
                //显示播放、暂停、刷新按钮
                Components.push(
                    { name: 'btnComponent', type: _this.btnComponent() },
                    { name: 'reloadComponent', type: _this.reloadComponent() }
                )
            }
            if (_this.showdm) {

                Components.push({
                    name: 'txtComponent',
                    type: _this.txtComponent()
                })
                // 自定义声音
                Components.push({
                    name: 'AudioCompotent',
                    type: _this.AudioCompotent(),
                    arg: [],
                })
                //显示码率切换按钮
                Components.push({
                    name: 'qualityComponent',
                    type: _this.qualityComponent()
                })
                //显示弹幕按钮
                Components.push({
                    name: 'dmComponent',
                    type: _this.dmComponent(),
                    arg: [],
                })
                //全屏发消息按钮
                Components.push({ name: 'fullComponent', type: _this.fullComponent() })
                //跑马灯
                if (this.bulletScreen != '') {
                    Components.push({ name: 'bulletComponent', type: _this.bulletComponent() })
                }
            }
            // 画中画
            if(_this.showPicture){
              //显示画中画
              Components.push({
                  name: 'PictureComponent',
                  type: _this.PictureComponent(),
                  arg: [],
              })

            }

            if (_this.showad && _this.adtcPic.pic_url != undefined) {
                //观看几分钟视频弹窗广告
                Components.push({ name: 'adComponent', type: _this.adComponent() })
            }
            // 所以，我们只能在 nextTick 里面初始化 Aliplayer
            _this.$nextTick(() => {
                _this.isReload = false
                _this.instance = window.Aliplayer(
                    {
                        id: _this.playerId,
                        autoplay: true,
                        isLive: _this.isLives,
                        playsinline: true,
                        // useH5Prism:true,
                        width: _this.width,
                        height: _this.height,
                        controlBarVisibility: _this.controlBarVisibility,
                        showBarTime: 1000 * 30,
                        preload: true,
                        source: _this.sources,
                        enableStashBufferForFlv: true,
                        stashInitialSizeForFlv: 32,
                        //cover: _this.cover,
                        liveRetry: 3,
                        waitingTimeout: 20,
                        skinLayout: [
                            {
                                name: 'thumbnail',
                            },
                            // {name: "bigPlayButton", align: "blabs", x: '40%', y: '40%'},
                            // {name:"H5Loading","align":"cc"},
                            {
                                name: 'controlBar',
                                align: 'blabs',
                                x: 0,
                                y: 0,
                                children: [
                                    {
                                        name: 'progress',
                                        align: 'blabs',
                                        x: 0,
                                        y: 44,
                                    },
                                    {
                                        name: 'playButton',
                                        align: 'tl',
                                        x: 15,
                                        y: 12,
                                    },
                                    {
                                        name: 'timeDisplay',
                                        align: 'tl',
                                        x: 20,
                                        y: 5,
                                    },
                                    { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
                                    { name: 'volume', align: 'tr', x: 20, y: 10 },
                                ],
                            },
                        ],
                        components: Components,
                    },
                    function (player) {
                        _this.dmclose = true
                        _this.dmshow('none', 0)
                        player.on('autoplay', function (data) {
                            if (data.paramData) {
                                //可以自动播放
                                _this.ismouted = false
                                player.setVolume(0.3)
                                player.play()
                                console.log('可以自动播放')
                                // _this.changeMouted(0)
                            } else {
                                //显示提示用户点击播放
                                player.mute()

                                if(!_this.rePlay ){
                                     _this.ismouted = true
                                    player.pause()
                                    _this.pause();
                                }
                                console.log('显示提示用户点击播放',player)
                                // _this.changeMouted(1)
                            }

                            // 先暂时关闭
                            if(_this.rePlay){
                                player.play()
                                player.off('autoplay')
                            }
                        _this.tabVolume()
                        })
                        
                    }
                )
                // 绑定事件，当 AliPlayer 初始化完成后，将编辑器实例通过自定义的 ready 事件交出去
                _this.instance.on('timeupdate', function (e) {
                    var s = _this.instance.getStatus()
                    let v = _this.instance.getVolume()
                    if (!_this.initTime) {
                        _this.initTime = _this.instance.getCurrentTime();
                    }
                    var time = _this.instance.getCurrentTime();
                    if (_this.islogin) {
                        let tt = time - _this.initTime
                        // localStorage.setItem('seeLive', _this.$store.state.user.info.uid + ',' + tt)
                        if (document.getElementById('adquality')) {
                            document.getElementById('hbPlayer').removeChild(document.getElementById('adquality'))
                        }
                    }
                    if ((time - _this.initTime >= _this.adtcPic.show_time) && _this.isfirst) {
                        if (document.getElementById('adtc')) {
                            document.getElementById('adtc').style.opacity = '1'
                            document.getElementById('adtc').style.zIndex = '200'
                        }
                    }
                    if (!_this.islogin && _this.qualityHD == 'hd' && _this.showdm) {
                        if (_this.seeTimes < _this.overTime) {
                            _this.seeTimes = _this.seeTime + (time - _this.initTime)
                            localStorage.setItem('seeDay', new Date().getDate() + ',' + _this.seeTimes)
                            if ((_this.seeTimes >= _this.overTime) && _this.hasSD) {
                                _this.isevent = 1
                                // _this.changeHD(1, 'sd')
                            }
                        } else if ((time - _this.initTime > _this.smallTime) && _this.smallshow && _this.hasSD) {
                            _this.isevent = 1
                            _this.smallshow = false
                            // _this.changeHD(1, 'sd')
                        }
                    }
                    if (v > 0) {
                        _this.ismouted = false
                    }
                    if (s == 'ready') {
                        _this.instance.play()
                    } else if (s == 'init') {
                        _this.state = 1
                    } else if (s == 'loading') {
                        _this.state = 2
                    } else if (s == 'waiting') {
                        _this.state = 0
                    } else if (s == 'playing') {
                        _this.state = 0
                        _this.waitcount = 0
                    } else if (s == 'ended') {
                        if (!_this.autochange) {
                            _this.state = 3
                            _this.waitcount = 0
                        }
                    }
                    if (s == 'ended' || s == 'error') {
                        _this.dmshow('none', 1)
                    } else {
                        _this.dmshow('block')
                    }
                    //console.log(s)
                })
                _this.instance.on('ready', () => {
                    this.$emit('ready', _this.instance)
                })
                _this.instance.on('play', () => {
                    this.$emit('play', _this.instance)
                })
                _this.instance.on('pause', () => {
                    this.$emit('pause', _this.instance)
                })
                _this.instance.on('ended', () => {
                    this.$emit('ended', _this.instance)
                })
                _this.instance.on('liveStreamStop', () => {
                    if (!_this.autochange) {
                        _this.state = 4
                        _this.dmshow('none', 0)
                    }
                    this.$emit('liveStreamStop', _this.instance)
                })
                _this.instance.on('m3u8Retry', () => {
                    if (!_this.autochange) {
                        _this.state = 2
                        _this.dmshow('none', 0)
                    }
                    this.$emit('m3u8Retry', _this.instance)
                })
                _this.instance.on('hideBar', () => {
                    this.$emit('hideBar', _this.instance)
                })
                _this.instance.on('waiting', () => {
                    this.$emit('waiting', _this.instance)
                })
                _this.instance.on('playing', () => {
                    _this.state = 0
                    _this.waitcount = 0
                    this.$emit('playing', _this.instance)
                })
                _this.instance.on('dispose', () => {
                    this.$emit('dispose', _this.instance)
                })
                _this.instance.on('requestFullScreen', () => {
                    if (_this.showdm) {
                        document.getElementById('fullDm').style.display = 'block'
                        let logintag = document.getElementsByClassName('nologin')[0]
                        let inputtag = document.getElementById('msgtext')
                        if (_this.islogin) {
                            logintag.style.display = 'none'
                            inputtag.style.display = 'block'
                        } else {
                            logintag.style.display = 'block'
                            inputtag.style.display = 'none'
                        }
                    }
                    this.$emit('requestFullScreen', _this.instance)
                })
                _this.instance.on('cancelFullScreen', () => {
                    if (_this.showdm) {
                        document.getElementById('fullDm').style.display = 'none'
                    }
                    this.$emit('cancelFullScreen', _this.instance)
                })
                _this.instance.on('error', () => {
                    _this.state = 4
                    _this.waitcount = 0
                    this.$emit('error', _this.instance)
                })
            })
        },
        // 显示弹幕
        dmshow (val, k) {
            let t = document.getElementById('content-barrage')
            if (t) {
                if (this.dmclose) {
                    t.style.display = 'none'
                    if (k == 0) {
                        t.innerHTML = ''
                    }
                } else {
                    t.style.display = val
                }
            }
        },
        // 显示
        adComponent () {
            var _this = this
            if (Aliplayer) {
                var adComponent = window.Aliplayer.Component({
                    /**
                     * 播放和暂停按钮切换
                     */
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'adtc'
                        this.$html.setAttribute('class', 'adtc')
                        this.$html.innerHTML = '<div class="codeimg" style="background: url(' + _this.adtcPic.pic_url + ') no-repeat top center;    background-size: 100%;"> <img src="' + _this.codeurl + '"  alt="龙珠直播" /></div>' +
                            '<div class="closead" id="closead"> </div>'
                    },
                    /**
                     * 创建广告Dom元素
                     */
                    createEl: function (el) {
                        let that = this.$html
                        this.$html.addEventListener('click', (e) => {
                            if (e.target.className == 'closead') {
                                setTimeout(() => {
                                    el.removeChild(that)
                                    _this.isfirst = false
                                }, 100)
                            }
                        })
                        el.appendChild(this.$html)
                    },
                })
                return adComponent
            } else {
                return false
            }
        },
        logoComponent () {
            var _this = this
            if (Aliplayer) {
                var logoComponent = window.Aliplayer.Component({
                    /**
                     * 播放和暂停按钮切换
                     */
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'video-logo'
                        this.$html.setAttribute('class', 'video-logo')
                    },
                    /**
                     * 创建广告Dom元素
                     */
                    createEl: function (el) {
                        el.appendChild(this.$html)
                    },
                })
                return logoComponent
            } else {
                return false
            }
        },
        // 播放器--按钮
        btnComponent () {
            var _this = this
            if (Aliplayer) {
                var btnComponent = window.Aliplayer.Component({
                    /**
                     * 播放和暂停按钮切换
                     */
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'prismbtn'
                        this.$html.innerHTML = "<span id='btnplay' class='zanting'></span>"
                    },
                    /**
                     * 创建广告Dom元素
                     */
                    createEl: function (el) {
                        this.$html.addEventListener('click', () => {
                            let t = document.getElementById('btnplay').className
                            if (t == 'zanting') {
                                _this.instance.pause()
                                _this.isplays = true;
                            } else {
                                _this.instance.play()
                                _this.isplays = false;

                            }
                        })
                        el.getElementsByClassName('prism-controlbar')[0].appendChild(
                            this.$html
                        )
                    },
                    ready: function (player, e) { },
                    /**
                     * 显示播放按钮
                     */
                    play: function (player, e) {
                        if (document.getElementById('btnplay')) {
                            document.getElementById('btnplay').className = 'zanting'

                        }
                    },
                    /**
                     * 显示播放按钮
                     */
                    pause: function (player, e) {
                        if (document.getElementById('btnplay')) {
                            document.getElementById('btnplay').className = 'bofang'
                            _this.isplays = true;

                        }
                    },
                    ended: function (player, e) {
                        if (document.getElementById('btnplay')) {
                            document.getElementById('btnplay').className = ''
                        }
                    },
                    /**
                     *  显示暂停按钮
                     */
                    playing: function (player, e) {
                        if (document.getElementById('btnplay')) {
                            document.getElementById('btnplay').className = 'zanting'

                        }
                    },
                })
                return btnComponent
            } else {
                return false
            }
        },
        reloadComponent: function () {
            var _this = this
            if (Aliplayer) {
                var reloadComponent = window.Aliplayer.Component({
                    /**
                     * 重播按钮
                     */
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'prismreload'
                        this.$html.innerHTML = "<span class='reload'> </span>"
                    },
                    /**
                     * 创建广告Dom元素
                     */
                    createEl: function (el) {
                        this.$html.addEventListener('click', () => {
                            _this.reloadPlayer(2, _this.sources, _this.isLives)
                        })
                        el.getElementsByClassName('prism-controlbar')[0].appendChild(
                            this.$html
                        )
                    },
                })
                return reloadComponent
            } else {
                return false
            }
        },
        htmlEscape (text) {
            return text.replace(/[<>"&]/g, function (match, pos, originalText) {
                switch (match) {
                    case '<':
                        return '&lt;'
                    case '>':
                        return '&gt;'
                    case '&':
                        return '&amp;'
                    case '"':
                        return '&quot;'
                }
            })
        },
        sendMsg () {
            if (this.islogin) {
                let content = document.getElementById('msgtext').value
                let sendText = document.getElementsByClassName('sendbtn')[0]
                if (content == '') {
                    return false
                } else if (content === this.$store.state.message.talk) {
                    this.setError('请勿刷屏')
                    return false
                } else {
                    if (this.send) {
                        this.send = false
                        sendText.innerText = `${this.cutTime}s`
                        let time = setInterval(() => {
                            if (this.cutTime <= 1) {
                                clearInterval(time)
                                sendText.innerText = '发送'
                                this.cutTime = this.sleep
                                this.send = true
                            } else {
                                this.cutTime--
                                sendText.innerText = `${this.cutTime}s`
                            }
                        }, 1000)
                        this.msgPost(content)
                    }
                }
            } else {
                this.setError('请先登录')
            }
        },
        msgPost: function (content) {
            content = this.htmlEscape(content)
            this.$axios
                .post('/chat/user/speak', {
                    content: content,
                    ...this.chatParams,
                })
                .then((res) => {
                    let { status, message, detail } = res
                    if (status === -11) {
                        this.cancelFullScreen()
                        this.$alert(message, '账号异常', {
                            confirmButtonText: '确定',
                            callback: (action) => {
                                this.$cookies.removeAll()
                                this.$store.commit('user/USERINFO', {})
                                this.$store.commit('user/OPENMODAL', {
                                    reg: false,
                                    login: true,
                                })
                            },
                        })
                    } else if (status === 2) {
                        let logintag = document.getElementsByClassName('nologin')[0]
                        logintag.style.display = 'block'
                        logintag.innerText = message
                        document.getElementById('msgtext').style.display = 'none'
                    } else if (status === 1) {
                        this.cancelFullScreen()
                        this.$store.commit('user/OPENMODAL', { reg: false, login: true })
                    } else if (status === 3) {
                        this.setError(message)
                    } else {
                        this.setError('')
                    }
                    document.getElementById('msgtext').value = ''
                    this.$store.commit('message/TALK', content)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        setError: function (txt) {
            let error = document.getElementsByClassName('error')[0]
            error.innerText = txt
            setTimeout(function () {
                error.innerText = ''
            }, 1000)
        },
        bulletComponent: function () {
            var _this = this
            if (Aliplayer) {
                var bulletComponent = window.Aliplayer.Component({
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'screenDm'
                        this.$html.innerHTML = '<marquee>' + _this.bulletScreen + '</marquee>'
                    },
                    createEl: function (el) {
                        el.appendChild(this.$html)
                    },
                })
                return bulletComponent
            } else {
                return false
            }
        },
        fullComponent: function () {
            var _this = this
            if (Aliplayer) {
                var fullComponent = window.Aliplayer.Component({
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'fullDm'
                        this.$html.innerHTML =
                            '<div class="error"></div> <div class="nologin">登录发弹幕，参与互动</div> <input  autocomplete="off"  placeholder="按回车键可快速发送弹幕"  maxlength="' +
                            _this.maxLen / 2 +
                            '" type="text" id="msgtext" /><div class="sendbtn">发送</div>'
                    },
                    createEl: function (el) {
                        // this.$html.addEventListener('click', (e) => {
                        //     if (_this.islogin) {
                        //         if (e.target.className == 'sendbtn') {
                        //             _this.sendMsg()
                        //         }
                        //     } else {
                        //         _this.cancelFullScreen()
                        //         _this.$store.commit('user/OPENMODAL', {
                        //             reg: false,
                        //             login: true,
                        //         })
                        //     }
                        // })
                        // this.$html.addEventListener('keydown', function (event) {
                        //     if (event.keyCode == '13') {
                        //         if (_this.islogin) {
                        //             _this.sendMsg()
                        //         } else {
                        //             _this.cancelFullScreen()
                        //             _this.$store.commit('user/OPENMODAL', {
                        //                 reg: false,
                        //                 login: true,
                        //             })
                        //         }
                        //     }
                        //     if (el.getElementsByClassName('prism-controlbar')) {
                        //         el.getElementsByClassName('prism-controlbar')[0].style.display = 'block'
                        //     }
                        // })
                        // el.getElementsByClassName('prism-controlbar')[0].appendChild(
                        //     this.$html
                        // )
                    },
                })
                return fullComponent
            } else {
                return false
            }
        },
        txtComponent: function () {
            var _this = this
            if (Aliplayer) {
                var txtComponent = window.Aliplayer.Component({
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'txtAlert'
                    },
                    createEl: function (el) {
                        el.appendChild(this.$html)
                    },
                })
                return txtComponent
            } else {
                return false
            }
        },
        qualityComponent: function () {
            var _this = this
            if (Aliplayer) {
              //也可以直接替换，target为要替换的dom对象，可以直接使用组件替换目标dom
              // <div class="changePopover"> <div>高清</div> <div>标清</div></div>
              let showmyTooltip = new Vue({
                template:'<div><el-popover popper-class="changePopoverItempopover" placement="top" width="30"  v-model="visible">  <div class="changePopover"> <div class="changePopoverItem" :class="fifClass(item)"  v-for="(item,index) in list" :key="index" @click="change(item)">{{item.name}}</div> </div> <div class="popovertxt" slot="reference"> <span>{{status}}</span> </div></el-popover></div>',
                data(){
                  return {
                    list:[
                      // {
                      //   name:'超清',
                      //   value:'ud',
                      //   id:1
                      // },
                      {
                        name:'高清',
                        value:'hd',
                        id:2
                      },
                      {
                        name:'标清',
                        value:'sd',
                        id:3
                      },
                      {
                        name:'流畅',
                        id:4,
                        value:'ld',
                      }
                    ],
                    visible:false,
                    status:'高清'
                  }
                },
                methods:{
                  fifClass(items){
                    if(items.name == this.status){
                      return 'changePopoverItemActive'
                    }
                  },
                  change(e){
                    console.log('切换高清度',e);
                    this.status = e.name
                    this.visible = false
                    _this.$emit('changeHD',e.value)
                  }
                }
              }).$mount();
                var qualityComponent = window.Aliplayer.Component({
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$html.id = 'quality'
                        // var html = '<div class="current-quality">蓝光</div><ul class="quality-list" style="display: none;"><li class="hd current">蓝光<i class="isloginicon"></i></li><li class="sd">标清</li></ul>'
                        // this.$html.innerHTML = html
                    },
                    createEl: function (el) {
                        this.$html.appendChild(showmyTooltip.$el)
                        el.getElementsByClassName('prism-controlbar')[0].appendChild(this.$html)
                        // this.$html.style.display = _this.hdlist.length > 0 ? 'block' : 'none'
                        // _this.classHD()
                    },
                })
                return qualityComponent
            } else {
                return false
            }
        },
        eventData (type, k) {
            if (this.isevent == 1) {
                if (k) {
                    localStorage.setItem('loginFrom', k)
                }
                this.$axios.post('/api/statistics/event', {
                    app_name: 'hbzb',
                    platform: 3,
                    app_version: '',
                    report_type: 2,
                    refer_page: this.anchor ? '14' : '13',
                    event_type: type,
                    device_id: '',
                    user_id: this.islogin ? this.$store.state.user.info.uid : '',
                    extend: ''
                })
            }
        },
        changeHD: function (k, name) {
            let _this = this
            if (k == 1) {
                let html = document.createElement(`div`)
                html.id = 'adquality'
                html.innerHTML = '<div class="closead" id="closead"> </div>' +
                    '<div class="leftside"> <span>扫码下载APP<br />永久免费看</span> <img src="' + this.codeurl + '" /></div>' +
                    '<div class="rightside">' +
                    '<div class="button"><span class="sd current">标清</span> <span class="hd"><i class="icon"></i> 蓝光10M</span></div>' +
                    '<div class="gologins">蓝光10M更快更超清尽在龙珠直播<em class="gologinss">去登录>></em></div>' +
                    '</div>'
                html.addEventListener('click', (e) => {
                    let t = e.target.className
                    if (t == 'gologinss') {
                        if (_this.instance.fullscreenService.getIsFullScreen()) {
                            _this.cancelFullScreen()
                        }
                        _this.$store.commit('user/OPENMODAL', { reg: false, login: true })
                        // _this.eventData(1, '2')
                    } else if (t == 'closead') {
                        // _this.eventData(5)
                    } else if (t == 'hd') {
                        if (_this.instance.fullscreenService.getIsFullScreen()) {
                            _this.cancelFullScreen()
                        }
                        // _this.eventData(3, '2')
                        _this.$store.commit('user/OPENMODAL', { reg: false, login: true })
                    }
                    document.getElementById('hbPlayer').removeChild(html)
                })
                document.getElementById('hbPlayer').appendChild(html)
                if (name) {
                    // _this.eventData(6)
                    _this.$emit('qualityChange', name)
                }
            } else {
                _this.$emit('qualityChange', name)
            }
        },
        // 弹幕组件
        dmComponent: function () {
            var _this = this
            if (Aliplayer) {

                let showmyTooltip = new Vue({
                  template:'<div><el-tooltip class="item" effect="dark" content="弹幕" placement="top"><div id="prismdm" class="openBtn"></div></el-tooltip></div>',
                }).$mount();
                var dmComponent = window.Aliplayer.Component({
                    init: function () {
                        this.$html = document.createElement(`div`)
                        this.$dmhtml = document.createElement(`div`)
                        this.$dmhtml.id = 'content-barrage'
                        this.$html.appendChild(showmyTooltip.$el)
                    },
                    createEl: function (el) {
                        this.$html.addEventListener('click', () => {
                            let t = document.getElementById('prismdm')
                            if (t.className == 'openBtn') {
                                t.setAttribute('class', 'closeBtn')
                                _this.dmclose = true
                                _this.dmshow('none', 1)
                            } else {
                                t.setAttribute('class', 'openBtn')
                                _this.dmclose = false
                                _this.dmshow('block')
                            }
                            console.log('弹幕开关', !_this.dmclose);
                            _this.$emit('changeDM',!_this.dmclose)
                        })

                        el.getElementsByClassName('prism-controlbar')[0].appendChild(
                            this.$html
                        )
                        el.appendChild(this.$dmhtml)
                    },
                })
                return dmComponent
            } else {
                return false
            }
        },
        // 发送弹幕消息
        sendDanmuHandle (danmuText, stime, own) {
            let commentSize = [14, 16, 18, 20, 22]
            let commentColor = ['#fff', '#0000ff', '#cc0000', '#ff66ff', '#ffff33']
            if (danmuText === '') {
                return
            }
            this.dmtop = this.dmtop + 25
            if (this.dmtop > 210) {
                this.dmtop = 0
            }
            this.SetBarrage({
                mode: this.dmtop,
                text: danmuText,
                stime: stime * parseInt(Math.random() * 12),
                // "stime":stime*this.randomIndex(11),
                size: commentSize[this.randomIndex(5)],
                own: own,
            })
        },
        // 声音组件
        AudioCompotent(){
          var _this = this
          if (Aliplayer) {
              //也可以直接替换，target为要替换的dom对象，可以直接使用组件替换目标dom
              let showmyTooltip = new Vue({
                template:'<div class="audiocontrol"><span @click="ijngyin" :class="AudioDombox"></span><div class="VideoSlider"><el-tooltip class="item" effect="dark" content="声音" placement="top"> <el-slider tooltip-class="tooltipClass" height="30" @change="change" v-model="value1"></el-slider></el-tooltip></div></div>',
                data(){
                  return {
                    value1:21
                  }
                },
                computed:{
                  AudioDombox(){
                    if(this.value1>0){
                      return 'AudioDombox'
                    }else{
                      return 'AudioDomboxClose'
                    }
                  }
                },
                methods:{
                  ijngyin(){
                    this.value1 = 0;
                    _this.setVolume(.3)
                  },
                  change(e){
                    console.log('声音变化', e / 100);
                    _this.setVolume(e / 100)
                  }
                }
              }).$mount();
              console.log('实例结果',showmyTooltip);
              let audioValue = 10;
              var AudioCompotent = window.Aliplayer.Component({
                  init: function () {
                      this.$html = document.createElement(`div`);
                      this.$html.id = 'AudioDom'                  // 画中画id
                      this.$html.appendChild(showmyTooltip.$el)
                  },
                  createEl: function (el) {
                      // 在控制栏的位置添-加画中画icon
                      el.getElementsByClassName('prism-controlbar')[0].appendChild( this.$html );
                      console.log('创建声音组件-----成功');
                    
                  },
              })
              return AudioCompotent
          } else {
              return false
          }
        },
        // 画中画组件
        PictureComponent(e){
          var _this = this
          if (Aliplayer) {
              //也可以直接替换，target为要替换的dom对象，可以直接使用组件替换目标dom
              // let myTooltip = Vue.extend(Tooltip)
              // let showmyTooltip = new myTooltip().$mount()
              // showmyTooltip.setData(this.index);

              //也可以直接替换，target为要替换的dom对象，可以直接使用组件替换目标dom
              let showmyTooltip = new Vue({
                template:'<div class="VideoSlider"> <el-tooltip class="item" effect="dark" content="画中画" placement="top"><span id="btnPicture" class="openpicture"></span></el-tooltip></div>',
                data(){
                  return {
                    'value1':2
                  }
                },
                methods:{
                  change(e){
                    console.log('声音变化',e);
                  }
                }
              }).$mount();

              var PictureComponent = window.Aliplayer.Component({
                  init: function () {
                      this.$html = document.createElement(`div`);
                      this.$html.id = 'PictureDom'                  // 画中画id
                     this.$html.appendChild(showmyTooltip.$el)


                      // this.$html.setAttribute('class', 'closeBtn')  // 设置样式
                      // this.$dmhtml = document.createElement(`div`)
                      // this.$dmhtml.id = 'content-Picture'

                  },
                  createEl: function (el) {
                    // 监听点击事件
                      this.$html.addEventListener('click', () => {
                          // let t = document.getElementById('btnPicture').className
                          let v = document.getElementById('hbPlayer').querySelector('video');
                          console.log(v);
                          if( _this.PictureClose){
                            v.requestPictureInPicture()
                             _this.PictureClose = false;
                          }else{
                            document.exitPictureInPicture()
                            _this.PictureClose = true;
                          }

                      })
                      // 在控制栏的位置添-加画中画icon
                      el.getElementsByClassName('prism-controlbar')[0].appendChild(
                          this.$html
                      )
                      console.log('创建画中画组件-----成功',this.$dmhtml);
                      // el.appendChild(this.$dmhtml)   // 在 播放器中添加画布
                  },
              })
              return PictureComponent
          } else {
              return false
          }
        },
        randomIndex (max) {
            return Math.floor(Math.random() * max)
        },
        SetBarrage (danmuku) {
            // 创建dom并添加class 和各种数据
            var barrage = document.createElement('div')
            barrage.className = 'content-barrage-single'
            barrage.innerHTML = danmuku.text
            if (window.Aliplayer && document.getElementById('content-barrage')) {
                const randomTime = this.Random(10, 15) * 1000
                barrage.style.top = danmuku.mode + 'px'
                barrage.style.animation = 'barrage 14s linear  0.1s 1 normal'
                barrage.className = danmuku.own
                    ? 'content-barrage-single on'
                    : 'content-barrage-single'
                setTimeout(() => {
                    document.getElementById('content-barrage').appendChild(barrage) // 创建弹幕从右到左面的10-15的随机秒数
                }, danmuku.stime)
                // 添加一个定时器 在运行完成之后删除这个DOM
                setTimeout(() => {
                    document.getElementById('content-barrage').removeChild(barrage)
                }, danmuku.stime + randomTime + 14)
            }
        },
        Random (start, end) {
            let num = (Math.random() * (end - start) + start).toString()
            return parseInt(num, 10)
        },
        /**
         *刷新
         */

        reload: function () {
            this.loadByUrl(this.sources, 0)
        },
        //非同级切换
        tabPlayer: function (k, val, isLive) {
            this.isReload = true
            if (this.instance) {
                this.instance.dispose()
            }
            this.sources = val
            this.isLives = isLive
            this.txtLive = isLive ? '直播' : '视频'
            this.initAliplayer()
        },
        /**
         * 切换同级视频
         */

        reloadPlayer: function (k, val, isLive) {
            this.isLives = isLive
            if (k == 2) {
                this.sources = val
            }
            this.txtLive = isLive ? '直播' : '视频'
            this.loadByUrl(this.sources, 0)
        },
        /**
      * 切换同级视频和码率
      */
        reloadPlayers: function (val, t) {
            if (document.getElementById('txtAlert') && t == undefined) {
                document.getElementById('txtAlert').innerHTML = this.qualityHD == 'hd' ? '正在为您切换蓝光10M直播' : '正在为您切换标清直播'
                document.getElementById('txtAlert').style.display = 'block'
                setTimeout(() => {
                    document.getElementById('txtAlert').style.display = 'none'
                }, 1500)
            }
            this.classHD()
            this.sources = val
            this.loadByUrl(this.sources, 0)
        },
        classHD: function () {
            document.getElementById("quality").style.display = this.hasHD || this.hasSD ? "block" : "none"
            document.getElementsByClassName("hd")[0].style.display = this.hasHD ? "block" : "none"
            document.getElementsByClassName("sd")[0].style.display = this.hasSD ? "block" : "none"
            if (this.qualityHD == 'hd') {
                document.getElementsByClassName("hd")[0].classList.add("current")
                document.getElementsByClassName("sd")[0].classList.remove("current")
                document.getElementsByClassName("current-quality")[0].innerText = "蓝光10M"
            } else {
                document.getElementsByClassName("hd")[0].classList.remove("current")
                document.getElementsByClassName("sd")[0].classList.add("current")
                document.getElementsByClassName("current-quality")[0].innerText = "标清"
            }
        },
        myplays(){
            this.setVolume(0.4)
            this.play()
        },
        play: function () {
            this.instance.play()
        },
        /**
         * 暂停视频
         */
        pause: function () {
            this.instance.pause();
        },
        playing: function () {
            this.instance.playing()
        },
        /**
         * 重播视频
         */
        replay: function () {
            this.instance.replay()
        },
        /**
         * 清空视频
         */
        dispose: function () {
            this.instance.dispose()
        },
        cancelFullScreen: function () {
            this.instance.fullscreenService.cancelFullScreen()
        },
        /**
         * 跳转到某个时刻进行播放
         * @argument time 的单位为秒
         */
        seek: function (time) {
            this.instance.seek(time)
        },
        /**
         * 获取当前时间 单位秒
         */
        getCurrentTime: function () {
            return this.instance.getCurrentTime()
        },
        /**
         *获取视频总时长，返回的单位为秒
         * @returns 返回的单位为秒
         */
        getDuration: function () {
            return this.instance.getDuration()
        },
        /**
           获取当前的音量，返回值为0-1的实数ios和部分android会失效
           */
        getVolume: function () {
            return this.instance.getVolume()
        },
        /**
          设置音量，vol为0-1的实数，ios和部分android会失效
        */
        setVolume: function (vol) {
            // this.ismouted = !this.ismouted
            this.instance.setVolume(vol)
        },
        getmouted: function () {
            return this.ismouted
        },
        /**
         *直接播放视频url，time为可选值（单位秒）目前只支持同种格式（mp4/flv/m3u8）之间切换暂不支持直播rtmp流切换
         *@argument url 视频地址
         *@argument time 跳转到多少秒
         */
        loadByUrl: function (url, time) {
            this.instance.loadByUrl(url, time?time:0)
        },
        /**
         * 设置播放速度
         *@argument speed 速度
         */
        setSpeed: function (speed) {
            this.instance.setSpeed(speed)
        },
        /**
         * 设置播放器大小w,h可分别为400px像素或60%百分比chrome浏览器下flash播放器分别不能小于397x297
         *@argument w 播放器宽度
         *@argument h 播放器高度
         */
        setPlayerSize: function (w, h) {
            this.instance.setPlayerSize(w, h)
        },
        /**
         * 目前只支持HTML5界面上的重载功能,暂不支持直播rtmp流切换m3u8）之间切换,暂不支持直播rtmp流切换
         *@argument vid 视频id
         *@argument playauth 播放凭证
         */
        reloaduserPlayInfoAndVidRequestMts: function (vid, playauth) {
            this.instance.reloaduserPlayInfoAndVidRequestMts(vid, playauth)
        },
    },
}
</script>
<style lang="scss" >



@import url("https://g.alicdn.com/de/prismplayer/2.8.8/skins/default/aliplayer-min.css");

.lzPlayer{

    .popper__arrow{
      border-top-color: #333 !important;
    }
    .el-popper  .popper__arrow{
      border-top-color: #333 !important;
    }
   .el-popper  .popper__arrow::after{
      border-top-color: #333 !important;
    }

     .el-slider__button-wrapper{
        height: 30px;
      }
      .el-slider__runway{
        margin:12px 0 !important;
        height: 3px;
        background: #958CA0;
        border-radius: 2px;

      }
        .el-slider__button{
          width: 8px;
          height: 8px;
          background: #FFFFFF;
          transform: translateY(1px);
          border: none !important;
        }
        .hover{
          // transform:scale(0.1);
          // transform: none !important
        }
        .el-slider__bar{
          height: 3px;
          background: linear-gradient(270deg, #04B0FF 0%, #085BFF 100%);
          border-radius: 2px;
        }
        .tooltipClass{
          background-color: #999 !important;
        }



          .popovertxt{
            height: 28px;
            display:flex;
            align-items: center;
            cursor: pointer;
            border-radius: 4px;
            span{
              width: 34px;
              height: 20px;
              text-align: center;
              display: inline-block;
              background: #333333;
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 20px;
            }
          }

          .prism-volume{
            display: none !important;
          }
        .tips {
            position: absolute;
            top: 5px;
            color: #fff;
            z-index: 101;
            text-align: center;
            background: rgba(237, 43, 64, 0.6);
            font-size: 12px;
            padding: 5px 0;
            width: 260px;
            left: 50%;
            margin-left: -130px;
            border-radius: 40px;
            cursor: pointer;
        }
        .video-logo {
          /* border: 1px solid red; */
            background: url('/static/newroom/videoloading.png') no-repeat center;
            /* background-color: rgba(0, 0, 0, 0.4); */
            width: 120px;
            height: 40px;
            background-size: 100%;
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 50;
        }
        .video-muted {
            width: 100px;
            line-height: 32px;
            color: #ff3551;
            background: url('/static/newroom/bofang.png') no-repeat left center;
            position: absolute;
            background-size: 100%;
            left: 50%;
            top:50%;
            transform: translate(-50%,-50%);
            cursor: pointer;
            // background-position-x: 10px;
            z-index: 999;
            height: 100px;
            img{
                width: 100px;
                height: 100px;
            }
        }

}


#screenDm {
    position: absolute;
    width: 100%;
    height: 35px;
    top: 2px;
    z-index: 9999;
    left: 0;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}
#fullDm {
    position: absolute;
    display: none;
    width: 800px;
    height: 35px;
    bottom: 2px;
    z-index: 9999;
    left: 50%;
    margin-left: -400px;
    text-align: center;
}
#fullDm input {
    line-height: 35px;
    outline: none;
    display: none;
    text-indent: 10px;
    border-radius: 8px 0px 0px 8px;
    float: left;
    border: 0;
    width: 700px;
    background: #fff;
    color: #333;
}
#fullDm .nologin {
    width: 700px;
    display: none;
    border-radius: 8px 0px 0px 8px;
    background: #fff;
    float: left;
    color: #333;
    line-height: 35px;
}
#fullDm .sendbtn {
    border-radius: 0px 8px 8px 0px;
    background: #ff3551;
    width: 88px;
    line-height: 35px;
    text-align: center;
    float: left;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}
#fullDm .error {
    position: absolute;
    top: -40px;
    left: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 16px;
}
#prismbtn {
    float: left;
    margin-top: 10px;
    margin-right: 15px;
}
#prismreload {
    float: left;
    margin-top: 10px;
    margin-right: 15px;
}
.zanting {
    cursor: pointer;
    background: url(/static/room/parse.png) no-repeat center;
    /* border: 1px solid red; */
    width: 28px;
    height: 28px;
    display: inline-block;
    background-size: 14px;
}
.bofang {
    cursor: pointer;
    background: url(/static/room/play.png) no-repeat center;
    /* border: 1px solid red; */
    width: 28px;
    height: 28px;
    display: inline-block;
    background-size: 16px;
}
.reload {
    cursor: pointer;
    background: url(/static/room/reload.png) no-repeat center;
    /* border: 1px solid red; */
    width: 28px;
    height: 28px;
    display: inline-block;
    background-size: 18px;
}
#quality {
    position: relative;
    float: right;
    margin-right: 20px;
    margin-top: 10px;
}
.current-quality {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 60px;
    height: 20px;
    margin-top: 4px;
    border-radius: 10px;
    background: #000;
    color: #fff;
    font-size: 12px;
}
.quality-list {
    bottom: 30px;
    display: none;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    left: -25px;
    background: #2c2c2c;
    border-radius: 4px;
}
.quality-list li {
    cursor: pointer;
    line-height: 38px;
    text-align: center;
    width: 88px;
    margin: 0 5px;
    color: #d7d7d7;
    border-bottom: 1px solid #232323;
}
.quality-list li i {
    /* background: url(../../assets/img/dl_icon.png) no-repeat center; */
    border: 1px solid red;

    width: 28px;
    height: 13px;
    background-size: 28px;
    position: absolute;
    top: 5px;
    right: 5px;
}
.quality-list li:last-child {
    border: 0;
}
.quality-list li.current {
    color: #ff3551;
    font-weight: bold;
}
#txtAlert {
    width: 438px;
    height: 80px;
    position: absolute;
    z-index: 200;
    top: calc(50% - 40px);
    left: 50%;
    margin-left: -219px;
    display: flex;
    justify-content: center;
    flex-flow: row;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
    display: none;
    justify-content: center;
    text-align: center;
    line-height: 80px;
}
#adquality {
    width: 438px;
    height: 180px;
    position: absolute;
    z-index: 200;
    top: calc(50% - 90px);
    left: 50%;
    margin-left: -219px;
    display: flex;
    justify-content: center;
    flex-flow: row;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
}
#adquality .leftside {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    padding: 0 25px;
    border-right: 1px solid #3b3b3b;
}
#adquality .leftside span {
    text-align: center;
}
#adquality .leftside img {
    width: 88px;
    height: 88px;
    display: inline-block;
    margin-top: 10px;
}
#adquality .closead {
    width: 30px;
    text-align: center;
    cursor: pointer;
    /* background: url(../../assets/img/icon_cha.png) no-repeat center; */
    border: 1px solid red;
    height: 30px;
    display: inline-block;
    background-size: 12px;
    position: absolute;
    top: 0;
    right: 0;
}
#adquality .rightside {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    flex: 1;
}
#adquality .rightside .button {
    display: flex;
    flex-flow: row;
    align-items: center;
    margin-top: 10px;
}
#adquality .rightside .button span {
    border: 1px solid #dddddd;
    width: 86px;
    line-height: 23px;
    border-radius: 5px;
    color: #fff;
    font-size: 12px;
    display: inline-block;
    cursor: pointer;
    margin-right: 15px;
    text-align: center;
    position: relative;
}
#adquality .rightside .button span.current {
    border: 1px solid #ed2b40;
    color: #ed2b40;
}
#adquality .rightside .button span {
    color: #fff;
    display: block;
    color: #fff;
    background: transparent;
    line-height: 23px;
}
#adquality .rightside .button span i.icon {
    width: 49px;
    text-align: center;
    /* background: url(../../assets/img/dlapp_icon.png) no-repeat center; */
    border: 1px solid red;
    height: 14px;
    display: inline-block;
    background-size: 49px;
    position: absolute;
    right: -15px;
    top: -10px;
}
#adquality .rightside .gologins {
    margin-top: 20px;
}
#adquality .rightside .gologins em {
    cursor: pointer;
    color: #ed2b40;
    padding-left: 5px;
}
#prismdm {
  display: inline-block;
    float: right;
    margin-right: 20px;
    margin-top: 10px;
}
.VideoSlider{
  min-width: 100px;
  height: 27px;
  display: inline;
  align-items: center;
  width: 100%;
  margin-left: 8px;
}
.audiocontrol{
  display: flex;
  align-items: center;
}
#AudioDom{
  float: right;
  margin-right: 30px;
  margin-top: 10px;
  // border: 1px solid red;
  display: inline-flex;
}
.AudioDomboxClose{
  cursor: pointer;
  background: url(/static/newroom/jingyin.png) no-repeat center;
  width: 28px;
  height: 28px;
  display: inline-block;
  background-size: 20px;
}
.AudioDombox{
  cursor: pointer;
  background: url(/static/room/shengyin.png) no-repeat center;
  /* border: 1px solid red; */
  width: 28px;
  height: 28px;
  display: inline-block;
  background-size: 20px;
}
/* 画中画组件 */
#PictureDom{
  float: right;
  margin-right:18px;
  margin-top: 10px;
  /* border: 1px solid red; */
}
.openpicture{
   /* border: 1px solid red; */
    cursor: pointer;
    background: url(~@/assets/img/smallVideo.png) no-repeat center;
    /* border: 1px solid red; */
    width: 28px;
    height: 28px;
    display: inline-block;
    background-size: 20px;
}
.openBtn {
    cursor: pointer;
    background: url(/static/room/danmu_kai.png) no-repeat center;
    /* border: 1px solid red; */
    background-size: 20px;
    width: 28px;
    height: 28px;
    display: inline-block;
}
.closeBtn {
    cursor: pointer;
    background: url(/static/room/danmu_close.png) no-repeat center;
    /* border: 1px solid red; */
    background-size: 20px;
    width: 28px;
    height: 28px;
    display: inline-block;
}
#content-barrage {
    height: 300px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
}
.content-barrage-single {
    /* top: 200px; */
    display: inline-block;
    padding: 1px 2px;
    position: absolute;
    white-space: nowrap;
    transition: all 0.3s;
    color: #fff;
    font-size: 20px;
    font-weight: normal;
    left: 100%;
    line-height: 22px;
    /* text-shadow: #000 0 0 1px, #000 0 0 1px, #000 0 0 1px;*/
}
.content-barrage-single img {
    width: 28px;
}
.content-barrage-single.on {
    color: #ff3551;
    border: 1px solid #ff3551;
}
/*  为了防止突兀的出现 现在是从又到左面的负一屏 但是影响性能 可以根据自己的业务场景修改 */

@keyframes barrage {
    100% {
        left: -1000px;
    }
}
.adtc {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 282px;
    position: absolute;
    top: calc(50% - 194px);
    z-index: 1;
    opacity: 0;
    left: 50%;
    margin-left: -141px;
}
.adtc .codeimg {
    width: 282px;
    height: 348px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.adtc .codeimg img {
    width: 130px;
    display: inline-block;
    height: 130px;
    margin-top: 90px;
    margin-left: 29px;
}
.adtc .closead {
    width: 252px;
    text-align: center;
    cursor: pointer;
    /* background: url(../../assets/img/circle.png) no-repeat center; */
    border: 1px solid red;
    height: 40px;
    display: inline-block;
    margin-left: 30px;
}
.errorbox {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    height: calc(100% - 32px);
}
.errorbox.bgbox {
    background: #272727;
}
.errorbox .text {
    width: 100%;
    color: #fff;
    font-size: 20px;
    text-align: center;
    margin-top: 20px;
}
.errorbox .text1 {
    width: 100%;
    color: #fff;
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
}
.errorbox .text img {
    width: 200px;
}
.errorbox .changebutton {
    display: flex;
    flex-flow: row;
    width: 100%;
    justify-content: center;
    margin-top: 30px;
}
.errorbox .changebutton span {
    width: 100px;
    cursor: pointer;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    color: #f34436;
    font-size: 18px;
    border: 1px solid #f34436;
    border-radius: 20px;
}
.novideo1 {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: column;
    background: #272727;
}
.novideo1 img {
    display: block;
}
.novideo1 span {
    color: #fff;
    font-size: 20px;
}
.prism-controlbar{
  // display: block !important;
}
.prism-player .prism-controlbar .prism-controlbar-bg {
    background: rgba(0, 0, 0, 0.4) !important;
}
#iframe {
    width: 100%;
    height: 0;
    overflow: hidden;
    border: 0;
    position: absolute;
    z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/aliplayer.vue